const forwardTrackingParameters = (urlString: string): string => {
  const url = new URL(urlString);
  const searchParams = new URLSearchParams(url.search);
  const currentSearchParams = new URLSearchParams(location.search);

  for (const elem of currentSearchParams.entries()) {
    // Overrides each value with the current utms for klaviyo and other
    // non-Repeat channels
    // Adds the _ke for klaviyo tracking
    if (elem[0].startsWith("utm_") || elem[0] == "_ke") {
      searchParams.set(elem[0], elem[1]);
    }
  }

  url.search = searchParams.toString();

  return url.toString();
};
export default forwardTrackingParameters;
